import '../../styles/arrow-button.css';

import ArrowFwsPrimary from '../../assets/icons/arrow-fwd-primary.svg';

export const ArrowButton = () => (
  <div className="arrow-button">
    <img
      src={ArrowFwsPrimary}
      alt="Arrow forward"
    />
  </div>
);
